import { IDanhSachNganh2ActionTypes } from "../../action-types/quan-ly-nganh-2/IDanhSachNganh2Actions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachNganh2Reducer } from "../../reducer-model/quan-ly-nganh-2/IDanhSachNganh2Reducer";

const iniState: IDanhSachNganh2Reducer = {
    status: eReducerStatusBase.is_not_initialization,
    danhSachNganh2s: [],
    currentTab: "danh-sach-nganh-2",
};

export const danhSachNganh2Reducer = (state: IDanhSachNganh2Reducer = iniState, action: IDanhSachNganh2ActionTypes): IDanhSachNganh2Reducer => {
    switch (action.type) {
        case "DANH_SACH_NGANH_2_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DANH_SACH_NGANH_2_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                danhSachNganh2s: action.payload,
            };
        case "DANH_SACH_NGANH_2_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DANH_SACH_NGANH_2_CHANGE_TAB":
            return {
                ...state,
                currentTab: action.payload,
            };
    }
    return state;
}